// 공지사항 목록 아이템 컴포넌트
import { ChevronRight } from 'lucide-react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { useLanguage } from '@/contexts/AppContext';
import { getTypeIcon, getTypeColor, formatAnnouncementDate } from './utils';
import type { Announcement, AnnouncementTranslations } from './types';

interface AnnouncementListItemProps {
  announcement: Announcement;
  translations: AnnouncementTranslations;
  onClick: (announcement: Announcement) => void;
}

export function AnnouncementListItem({
  announcement,
  translations,
  onClick,
}: AnnouncementListItemProps) {
  const { language } = useLanguage();
  return (
    <Card
      onClick={() => onClick(announcement)}
      className="overflow-hidden bg-background border-0 rounded-[5px] transition-all duration-150 cursor-pointer active:scale-[0.98]"
    >
      <div className="p-4">
        <div className="flex items-start gap-3">
          {/* Type Icon */}
          <div className={`p-2 rounded-[5px] ${getTypeColor(announcement.type)} shrink-0`}>
            {getTypeIcon(announcement.type)}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-start gap-2 mb-1">
              <h3 className="text-[14px] font-bold text-foreground flex-1 line-clamp-1">
                {announcement.title}
              </h3>
              {!announcement.isRead && (
                <Badge className="bg-destructive text-destructive-foreground text-[9px] px-2 py-0.5 shrink-0 rounded-[3px] font-bold border-0">
                  {translations.new}
                </Badge>
              )}
            </div>

            <p className="text-[12px] text-muted-foreground mb-2 line-clamp-1">
              {announcement.summary}
            </p>

            <p className="text-[11px] text-muted-foreground">
              {formatAnnouncementDate(announcement.date, language)}
            </p>
          </div>

          {/* Arrow Icon */}
          <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0 mt-1" />
        </div>
      </div>
    </Card>
  );
}
